import { Mic, MicOff } from "lucide-react";
import { useEffect } from "react";
import { useAppSelector } from "../../../store/hooks";
import FullscreenBtn from "./FullscreenBtn";
import styles from "./TutorLiveScreen.module.css";

const StudentToolbar = ({
  isStarted,
  isMuted,
  isMicLoading,
  isRTCStarted,
  joinCall,
  toggleMic,
  toggleHandRaise,
}: {
  isStarted: boolean | null;
  isMuted: boolean | null;
  isMicLoading: boolean;
  isRTCStarted: boolean;
  joinCall: () => Promise<void>;
  toggleMic: () => Promise<void>;
  toggleHandRaise: () => void;
}) => {
  const { hands_raised, allowed_to_speak } = useAppSelector(
    (state) => state.liveSession
  );
  const { uid } = useAppSelector((state) => state.store.user);

  useEffect(() => {
    if (!isStarted) return;
    joinCall();
  }, [joinCall]);

  return (
    <div className={styles.studentControls}>
      <button
        className={`${styles.micBtn} ${
          !allowed_to_speak.includes(uid)
            ? styles.disabled
            : !isMuted
            ? styles.active
            : ""
        }`}
        onClick={toggleMic}
        disabled={isMicLoading || !allowed_to_speak.includes(uid)}
      >
        {!isMuted ? (
          <Mic className="text-white" />
        ) : (
          <MicOff className="text-primary" />
        )}
      </button>
      <button
        className={`${hands_raised.includes(uid) ? styles.active : ""}`}
        onClick={toggleHandRaise}
        // disabled={!isRTCStarted}
      >
        {hands_raised.includes(uid) ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="white"
            className="bi bi-person-raised-hand"
            viewBox="0 0 16 16"
          >
            <path d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207" />
            <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="#1c4d57"
            className="bi bi-person-raised-hand"
            viewBox="0 0 16 16"
          >
            <path d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207" />
            <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
          </svg>
        )}
      </button>
      <FullscreenBtn />
    </div>
  );
};

export default StudentToolbar;
